/* albm-drawer-panels.js — <albm-drawer-panels> · OWNER: T0
   Chuyển cây <details> 3 cấp của snippets/header-drawer.liquid (Dawn) thành panel trượt
   drill-down + nút 戻る. KHÔNG đụng <header-drawer>/<menu-drawer> của Dawn — focus trap,
   khoá scroll và Esc vẫn do global.js xử lý.

   Hợp đồng markup mà T1 phải giữ:
     <albm-drawer-panels>
       <div data-albm-panel data-level="1"> … </div>
       <button data-albm-drill="PanelId">…</button>
       <div data-albm-panel data-level="2" id="PanelId">
         <button data-albm-back>戻る</button> …
       </div>
     </albm-drawer-panels>
*/
class AlbmDrawerPanels extends HTMLElement {
  connectedCallback() {
    this.panels = Array.from(this.querySelectorAll('[data-albm-panel]'));
    if (!this.panels.length) return;
    this.stack = [this.panels.find((p) => p.dataset.level === '1') || this.panels[0]];

    this.querySelectorAll('[data-albm-drill]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        const target = document.getElementById(btn.dataset.albmDrill);
        if (target) this.push(target);
      });
    });

    this.querySelectorAll('[data-albm-back]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        this.pop();
      });
    });

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.stack.length > 1) {
        event.stopPropagation();
        this.pop();
      }
    });

    this.sync();
  }

  push(panel) {
    this.stack.push(panel);
    this.sync();
    (panel.querySelector('[data-albm-back]') || panel).focus?.();
  }

  pop() {
    if (this.stack.length <= 1) return;
    const closed = this.stack.pop();
    this.sync();
    const opener = this.querySelector(`[data-albm-drill="${closed.id}"]`);
    opener?.focus();
  }

  reset() {
    this.stack = this.stack.slice(0, 1);
    this.sync();
  }

  sync() {
    const active = this.stack[this.stack.length - 1];
    this.panels.forEach((panel) => {
      const isActive = panel === active;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      panel.querySelectorAll('a, button').forEach((el) => {
        if (isActive) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', '-1');
      });
    });
    this.dataset.level = String(this.stack.length);
  }
}

if (!customElements.get('albm-drawer-panels')) {
  customElements.define('albm-drawer-panels', AlbmDrawerPanels);
}
